import type {
  Image,
  LinkProps,
  ImageProps,
} from '@wix/thunderbolt-components-native';
import type { InferExtendedPropsSchema } from '@wix/lean-components-infra';
import type { PickStateRefValues } from '@wix/editor-elements-integrations';
import type { IFastGalleryProps } from './FastGallery.props';
import type props from './FastGallery.props';
import styles from './viewer/style/FastGallery.scss';

export type IFastGalleryStateValues = PickStateRefValues<'editorType'>;

export type IFastGalleryMapperProps = InferExtendedPropsSchema<typeof props>;

export type IFastGalleryControllerProps = IFastGalleryMapperProps & {
  setIsExpanded(isExpanded: boolean): void;
};

export type OrganizeMediaPanelItems = Image & {
  id: string;
  title: string;
  uri: string;
  alt: string;
  height: number;
  width: number;
  type: string;
};

export const FastGalleryLayout = {
  'Custom Grid': 'Custom Grid',
  Slider: 'Slider',
  Masonry: 'Masonry',
  Slideshow: 'Slideshow',
};

export const CLICK_ACTION = {
  ACTION: 'ACTION',
  LINK: 'LINK',
  NOTHING: 'NOTHING',
};

export const CustomGridMode = {
  vertical: 'vertical',
  horizontal: 'horizontal',
};

export const ItemInfoPosition = {
  BELOW: 'BELOW',
  ABOVE: 'ABOVE',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  ON_IMAGE: 'ON_IMAGE',
};

export const ItemElementsAlignment = {
  'flex-start': 'flex-start',
  center: 'center',
  'flex-end': 'flex-end',
  'space-between': 'space-between',
  'space-around': 'space-around',
  'space-evenly': 'space-evenly',
};

export type IFastGalleryDataProps = {
  items: Array<OrganizeMediaPanelItems>;
  wixSDKItems: Array<WixSDKItem>;
  downloadProtection: boolean;
  itemClickAction: keyof typeof CLICK_ACTION;
};

export type FastGalleryItemState = 'regular' | 'hover';

export type FastGalleryPreviewMapperProps = {
  partToPreviewStateMap?: {
    root?: FastGalleryItemState;
    item?: FastGalleryItemState;
    image?: FastGalleryItemState;
    overlay?: FastGalleryItemState;
    counter?: FastGalleryItemState;
    info?: FastGalleryItemState;
  };
};

export interface ItemProps {
  image: OrganizeMediaPanelItems;
  index: number;
  state?: FastGalleryItemState;
}

export type IFastGalleryCompProps = IFastGalleryProps &
  Partial<FastGalleryPreviewMapperProps>;
export interface IWixSDKImageSettings {
  focalPoint?: [number, number];
}
export type IWixSDKItemLink =
  | {
      url: string;
      target: string;
    }
  | string;

interface IWixSDKVideo {
  type: 'video';
  slug?: string;
  src: string;
  description?: string;
  title?: string;
  link?: string;
  thumbnail?: string;
}
interface IWixSDKImage {
  type: 'image';
  slug?: string;
  src: string;
  description?: string;
  title?: string;
  link?: IWixSDKItemLink;
  alt?: string;
  settings?: IWixSDKImageSettings;
}

export type WixSDKItem = IWixSDKImage | IWixSDKVideo;

export type WixSDKItems = Array<WixSDKItem>;

export type GalleryItemProps = {
  dataId: string;
  title?: string;
  description?: string;
  image: ImageProps;
  link?: LinkProps;
};

export const stylesSelectors = {
  root: `.${styles.root}`,
  item: `.${styles.item}`,
};

export const hoverStates = {
  rootHover: 'root-hover',
  itemHover: 'item-hover',
};
